export default __webpack_public_path__ + "static/media/cloud-2-day.106da97e.svg";